import { createReducer, on } from '@ngrx/store';
import * as StatisticsActions from '../actions/statistics.actions';

export const statisticsFeatureKey = 'statistics';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StatisticsActions.loadStatistics, (state) => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StatisticsActions.loadStatisticsSuccess, (state, action) => ({
    record: action.data['data'],
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StatisticsActions.loadStatisticsFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StatisticsActions.clearStatisticsState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

